import { Box, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        mt: 6,
        py: 5,
        px: 2,
        backgroundColor: "#f9f9f9",
        borderTop: "1px solid #e0e0e0",
      }}
    >
      {/* 🔥 CTA BLOCK */}
      <Box
        sx={{
          mb: 5,
          p: { xs: 3, md: 4 },
          borderRadius: 3,
          background: "linear-gradient(135deg, #FFF3E8, #FFE4D1)",
          textAlign: "center",
          boxShadow: "0 8px 24px rgba(0,0,0,0.05)",
          maxWidth: 800,
          mx: "auto",
        }}
      >
        {/* Headline */}
        <Typography variant="h5" fontWeight={700} sx={{ mb: 1 }}>
          Create Your Marriage Biodata in Minutes
        </Typography>

        {/* Subtext */}
        <Typography
          sx={{
            mb: 2,
            color: "#555",
            fontSize: "1rem",
            lineHeight: 1.6,
            maxWidth: 600,
            mx: "auto",
          }}
        >
          Build a professional biodata for Bride, Groom, or WhatsApp format.
          Simple, fast, and completely free — no signup required.
        </Typography>

        {/* Trust Signals */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: 2,
            flexWrap: "wrap",
            mb: 3,
            fontSize: "0.9rem",
            color: "#666",
          }}
        >
          <span>✔ Free to use</span>
          <span>✔ Instant PDF Download</span>
          <span>✔ Mobile Friendly</span>
        </Box>

        {/* CTA Button */}
        <Box
          component={RouterLink}
          to="/create-biodata"
          sx={{
            textDecoration: "none",
            background: "#CC5500",
            color: "#fff",
            px: 3,
            py: 1.2,
            borderRadius: "8px",
            fontWeight: 600,
            fontSize: "1rem",
            display: "inline-block",
            transition: "all 0.3s ease",
            "&:hover": {
              background: "#b34700",
              transform: "translateY(-2px)",
              boxShadow: "0 6px 14px rgba(0,0,0,0.15)",
            },
          }}
        >
          Create Free Biodata →
        </Box>
      </Box>

      {/* 🔹 GRID SECTION */}
      <Box
        sx={{
          maxWidth: 1100,
          mx: "auto",
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "1fr 1fr",
            md: "1fr 1fr 1fr",
          },
          gap: 4,
          mb: 4,
        }}
      >
        {/* 🔸 Brand */}
        <Box>
          <Typography variant="h6" fontWeight={700} gutterBottom>
            MarriageBiodata.live
          </Typography>

          <Typography variant="body2" color="text.secondary">
            Create professional marriage biodata online in minutes. Simple,
            fast, and free.
          </Typography>
        </Box>

        {/* 🔸 Important Links */}
        <Box>
          <Typography fontWeight={600} mb={1}>
            Important Links
          </Typography>

          <Box display="flex" flexDirection="column" gap={0.7}>
            <RouterLink to="/">Home</RouterLink>
            <RouterLink to="/about">About Us</RouterLink>
            <RouterLink to="/contact-us">Contact Us</RouterLink>
            <RouterLink to="/privacy-policy">Privacy Policy</RouterLink>
            <RouterLink to="/terms-conditions">Terms & Conditions</RouterLink>
            <RouterLink to="/disclaimer">Disclaimer</RouterLink>
          </Box>
        </Box>

        {/* 🔸 Popular Articles */}
        <Box>
          <Typography fontWeight={600} mb={1}>
            Popular Articles
          </Typography>

          <Box display="flex" flexDirection="column" gap={0.7}>
            <RouterLink to="/articles/biodata-format-for-bride">
              Bride Biodata Format
            </RouterLink>
            <RouterLink to="/articles/biodata-format-for-groom">
              Groom Biodata Format
            </RouterLink>
            <RouterLink to="/articles/modern-marriage-biodata-format-2026">
              Modern Biodata (2026)
            </RouterLink>
            <RouterLink to="/articles/whatsapp-marriage-biodata-format">
              WhatsApp Biodata Format
            </RouterLink>
            <RouterLink to="/articles/best-hobbies-for-marriage-biodata">
              Hobbies for Biodata
            </RouterLink>
          </Box>
        </Box>
      </Box>

      {/* 🔻 BOTTOM */}
      <Box textAlign="center">
        <Typography variant="body2" color="text.secondary">
          © {new Date().getFullYear()} MarriageBiodata.live. All rights reserved.
        </Typography>
      </Box>
    </Box>
  );
}